export const DefaultImagePlaceholderSrc = 'assets/images/placeholders/default.png';
export const DefaultProductImagePlaceholderSrc = 'assets/images/placeholders/product.png';
export const DefaultConsultantImagePlaceholderSrc = 'assets/images/placeholders/consultant.jpg';
export const FlagImageSrc = {
  americanFlag: 'assets/images/flags/us.png',
  mexicanFlag: 'assets/images/flags/mx.png',
};
export const DefaultVideoThumbnailPlaceholderSrc = 'assets/images/placeholders/video-thumbnail.png';
export const SnaConsultantProfileImagePlaceholderSrc = 'assets/images/icons/logo-small.svg';
